import { RESULT_EVENT_PREFIX, RESULT_KEYS } from "common/resultKeys";

export const cursorSnapshots = new Map();
export let cursorCacheVersion = 0;
export const CURSOR_LIST_INVALIDATED = "muyeon:cursor-lists-invalidated";

export function invalidateCursorLists() {
  cursorSnapshots.clear();
  cursorCacheVersion++;
  if (typeof window !== "undefined") window.dispatchEvent(new Event(CURSOR_LIST_INVALIDATED));
}

// Native editors and block actions can finish while a web list remains mounted underneath.
if (typeof window !== "undefined") {
  [RESULT_KEYS.PROFILE, RESULT_KEYS.RESUME, RESULT_KEYS.JOB_POSTINGS, RESULT_KEYS.LESSONS,
    RESULT_KEYS.REVIEWS, RESULT_KEYS.MEMBERSHIP, RESULT_KEYS.ACADEMY, RESULT_KEYS.CHAT_ROOMS]
    .forEach((key) => window.addEventListener(RESULT_EVENT_PREFIX + key, invalidateCursorLists));
  window.addEventListener("muyeonForceLogout", invalidateCursorLists);
}
